import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import '../styles/disenocalculadorasbase.css';
import fondo from '../assets/vivienda.webp';

export default function CalculadoraVivienda() {
  const navigate = useNavigate();
  
  // ===== ESTADOS =====
  const [nombre, setNombre] = useState("");
  const [edad, setEdad] = useState("");
  const [ingreso, setIngreso] = useState("");
  const [tiempo, setTiempo] = useState("");
  const [crecimiento] = useState("9");

  // ===== FUNCIONES =====
  const handleSubmit = () => {
    // Validaciones
    if (!nombre || !edad || !ingreso || !tiempo) {
      Swal.fire({
        icon: "warning",
        title: "Campos incompletos",
        text: "Por favor, completa todos los campos.",
      });
      return;
    }

    if (isNaN(edad) || edad <= 0 || edad > 99) {
      Swal.fire({
        icon: "error",
        title: "Edad inválida",
        text: "Por favor, ingresa una edad válida entre 1 y 99.",
      });
      return;
    }

    if (isNaN(ingreso) || ingreso <= 0) {
      Swal.fire({
        icon: "error",
        title: "Ingreso inválido",
        text: "El ingreso debe ser un número mayor que cero.",
      });
      return;
    }


    navigate("/DisplayCalculo", {
      state: { nombre, edad, ingreso, tiempo, crecimiento}
    });
  };

  const handleEdadChange = (e) => {
    const valor = e.target.value;
    if (valor === "" || (Number(valor) >= 1 && Number(valor) <= 99)) {
      setEdad(valor);
    }
  };

  // ===== RENDERIZADO =====
  return (
    <>
      {/* Botón de regreso */}
      <button
        onClick={() => navigate('/')}
        className="calculadora-back"
      >
        ← Regresar al Menú
      </button>

      <div className="calculadora-container">
        {/* Sección izquierda con imagen */}
        <div 
          className="calculadora-left"
          style={{ backgroundImage: `url(${fondo})` }}
        >
          <div className="calculadora-overlay">
            <h1>Construye el hogar que sueñas</h1>
            <p>
              Llena este formulario y obtén una proyección personalizada para tu plan de vivienda.
              ¡Hazlo realidad hoy!
            </p>
          </div>
        </div>

        {/* Formulario */}
        <div className="calculadora-form">
          <h2>Calculadora de Vivienda</h2>

          <label>Nombre:</label>
          <input 
            type="text" 
            value={nombre} 
            onChange={(e) => setNombre(e.target.value)} 
          />

          <label>Edad:</label>
          <input
            type="number"
            value={edad}
            onChange={handleEdadChange}
            min="1"
            max="99"
          />

          <label>Ingreso al fondo (mensualmente):</label>
          <input 
            type="number" 
            value={ingreso} 
            onChange={(e) => setIngreso(e.target.value)} 
          />

          <label>Tiempo (en años):</label>
          <select 
            value={tiempo} 
            onChange={(e) => setTiempo(e.target.value)}
          >
            <option value="">Selecciona un tiempo</option>
            {[...Array(25)].map((_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </select>

          <button onClick={handleSubmit} className="calculadora-btn">
            Crear Cálculo
          </button>

          <p
            onClick={() => navigate("/pantallaCIT")}
            className="calculadora-link"
          >
            El hogar de tus sueños está esperando, ¡agenda tu cita aquí!
          </p>
        </div>
      </div>
    </>
  );
}